import { Icon24Share } from '@vkontakte/icons';
import {
  Div, Group, Link, Panel, PanelHeader, PanelHeaderBack, Spacing
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { FC, useCallback } from 'react';
import { VKShareButton } from 'react-share';
import { AppPanels, AppPanelsT } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';
import { ReactComponent as VKLogo } from 'src/shared/assets/icons/VKLogo.svg';

import { shareToVkInVkFx, shareToVkStandaloneFx } from 'src/entity/Voiting';
import { APP_URL, VK_SHARE_TITLE, VK_SHARE_URL } from 'src/shared/config';
import { Cover } from 'src/shared/ui/cover';
import { SuperBtn } from 'src/shared/ui/superBtn';

import { HeroesRow } from 'src/entity/HeroesVkStatus';
import { resetSecondStageVotes } from 'src/entity/Pretendents';
import { $isStandAlone, GetVKAccessTokenGate } from 'src/entity/User';
import { setImageStatusId } from 'src/features/setImageStatus';

import bridge from '@vkontakte/vk-bridge';

import { Title, TitleSize } from '../../../shared/ui/title/Title';
import styles from './styles.module.scss';

export interface IFinalPanel {
  id: AppPanelsT;
}

export const FinalPanel: FC<IFinalPanel> = ({ id }) => {
  const [
    shareToVkInVk,
    shareToVkStandalone,
    onSetActivePanel,
    isStandAlone,
    onSetImageStatusId,
    onResetSecondStageVotes
  ] = useUnit([
    shareToVkInVkFx,
    shareToVkStandaloneFx,
    setActivePanel,
    $isStandAlone,
    setImageStatusId,
    resetSecondStageVotes
  ]);

  const onImageStatusClick = useCallback((imageStatusId: number) => {
    onSetImageStatusId(imageStatusId);
  }, [onSetImageStatusId]);

  const onBackClick = () => {
    onSetActivePanel(AppPanels.INTRO);
    onResetSecondStageVotes();
  };

  const onShowResultsClick = () => {
    onSetActivePanel(AppPanels.SECOND_STAGE_NOMINATIONS);
  };

  const onPlayButtonClick = useCallback(() => {
    onSetActivePanel(AppPanels.PUZZLE_GAME);
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'play_click',
      screen: 'final'
    });
  }, [onSetActivePanel]);

  return (
    <Panel id={id}>
      <PanelHeader
        transparent
        visor={false}
        separator={false}
        style={{ width: '0px' }}
        before={(
          <button
            type='button'
            className={styles.back}
            onClick={onBackClick}
          >
            <PanelHeaderBack />
            <span>На главную</span>
          </button>
        )}
      />
      <Group className={styles.results}>
        <Div className={styles.info}>
          {/* <Spacing size={18} />
          {isStandAlone ? (
            <Link
              target='_blank'
              href={`${APP_URL}#${AppPanels.FINAL}`}
            >
              <SuperBtn
                size='l'
                text='Установить эмодзи-статус'
                color='2'
              />
            </Link>
          ) : (
            <>
              <GetVKAccessTokenGate />
              <HeroesRow
                onImageStatusClick={onImageStatusClick}
              />
            </>
          )} */}

          {/* <Spacing size={18} />

          <Title
            align='center'
            size={TitleSize.XS}
          >
            Выбери свой эмодзи-статус
          </Title> */}

          <Spacing size={18} />

          <Title
            align='center'
            size={TitleSize.L}
          >
            Спасибо!
          </Title>

          <Spacing size={18} />

          <SuperBtn
            size='s'
            text='Играть'
            color='3'
            onClick={onPlayButtonClick}
          />

          {/* <Div className={styles.share}>
            {isStandAlone ? (
              <Div>
                <Title
                  align='center'
                  size={TitleSize.XS}
                  className={styles.share__title}
                >
                  Поделиться
                </Title>

                <Div className={styles.share__buttons}>
                  <VKShareButton
                    onClick={shareToVkStandalone}
                    url={VK_SHARE_URL}
                    title={VK_SHARE_TITLE}
                    className='results__share-button'
                  >
                    <VKLogo />
                  </VKShareButton>
                </Div>
              </Div>
            ) : (
              <SuperBtn
                text='Поделиться'
                color='1'
                onClick={shareToVkInVk}
                after={<Icon24Share />}
              />
            )}
          </Div>
          <Spacing size={18} />
          <SuperBtn
            text='Посмотреть результаты'
            color='3'
            onClick={onShowResultsClick}
          /> */}
          <Spacing size={18} />
        </Div>
      </Group>
      <Cover />
    </Panel>
  );
};
